import { Controller } from "@hotwired/stimulus"
import {translate as t} from 'common/i18n'
import Dialog from 'common/dashboard/dashboard/dialog'
import toastr from 'toastr'
import $ from 'jquery'

toastr.options = {"closeButton": true, "progressBar": true, "timeOut": "10000" }

export default class extends Controller {
  static targets = [
    'dialog',
    'form',
    'authForm',
    'errors',
    'closeBtn',
    'confirmBtn'
  ]
  static values = {
    disableTfaUrl: String,
  }

  connect() {
    $(this.dialogTarget).on('closed.zf.reveal', ()=> this.dispatch("reload", {prefix: false}))
  }

  async start() {
    let confirm = {
      title: t('users.disable_tfa.title'),
      message: t('users.disable_tfa.warning')
    }
    if(await Dialog.confirm(confirm)) {
      $(this.dialogTarget).foundation('open')
      this.perform()
    }
  }

  async perform() {
    let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken,
    }

    headers = Object.assign(headers, await this.#authController.authHeaders())

    this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify([])

    this.#beginLoad()

    const req = new Request(this.disableTfaUrlValue)
    const params = {
      method: 'PATCH',
      headers: headers,
      'body': JSON.stringify({})
    }
    let response = await fetch(req, params)

    if(response.status < 300) {
      $(this.dialogTarget).foundation('close')
      toastr.success(t('users.disable_tfa.success'))

    } else if(response.status === 403) {
      const {error, messages, credentials} = await response.json()
      this.authFormTarget.dataset['users-AuthenticationFormMethodsValue'] = JSON.stringify(credentials)
      this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify(messages)
    }

    this.#endLoad()
  }

  get #authController() {
    return this.application.getControllerForElementAndIdentifier(this.authFormTarget, 'users--authentication-form')
  }
  
  #beginLoad() {
    if(!this._mask) {
      this._mask = document.createElement('div')
      this._mask.classList.add('loading-mask')
      this._mask.innerHTML = '<i class="fas fa-spinner fa-3x fa-spin"></i>'
      this.dialogTarget.appendChild(this._mask)
    }
  }

  #endLoad() {
    if(this._mask) {
      this._mask.remove()
      this._mask = null
    }
  }
}
